var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartyPopperOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1748_40894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53174 36.4696L26.5873 28.2355L11.7659 13.4141L3.53174 36.4696ZM20.5764 26.8851L8.96626 31.0351L13.1163 19.425L20.5764 26.8851Z",
    fill: "#00234B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1665 20.8745L33.3723 11.6688C34.1792 10.8618 35.4802 10.8618 36.2872 11.6688L37.2588 12.6404L39.0044 10.8948L38.0328 9.92314C36.2707 8.16104 33.3888 8.16104 31.6267 9.92314L22.4209 19.1289L24.1665 20.8745Z",
    fill: "#00234B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8051 11.5696L15.8335 12.5413L17.5791 14.2869L18.5508 13.3153C20.3129 11.5532 20.3129 8.67123 18.5508 6.90913L17.5791 5.9375L15.8335 7.6996L16.8051 8.67123C17.5956 9.46171 17.5956 10.7792 16.8051 11.5696Z",
    fill: "#00234B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3328 19.806L25.7144 22.4244L27.46 24.17L30.0784 21.5516C30.8854 20.7446 32.1864 20.7446 32.9933 21.5516L35.6447 24.203L37.3903 22.4573L34.739 19.806C32.9604 18.0438 30.0949 18.0438 28.3328 19.806Z",
    fill: "#00234B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0391 9.9235L19.127 15.8356L20.8726 17.5812L26.7847 11.6691C28.5468 9.90703 28.5468 7.02509 26.7847 5.26298L24.1662 2.64453L22.4206 4.39017L25.0391 7.00862C25.8295 7.81556 25.8295 9.13302 25.0391 9.9235Z",
    fill: "#00234B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1748_40894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.5238,
    height: 39.5238,
    fill: "white",
    transform: "translate(0.238281 0.238281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyPopperOutlined);
export default __webpack_public_path__ + "static/media/party-popper-outlined.807369daa32f0ecc010b26980ec15da6.svg";
export { ForwardRef as ReactComponent };